import { Component, OnInit } from '@angular/core';

import { PickupComponent } from '../../pickup.shared.component';

@Component({
    selector: 'shared-pickup-for-hero',
    templateUrl: './pickup-for-hero.shared.component.html',
    styleUrls: ['./pickup-for-hero.shared.component.scss']
})
export class PickupForHeroComponent extends PickupComponent implements OnInit {
    public isVisible: boolean = false;

    ngOnInit(): void {
        this.mode = 'hero';
        super.ngOnInit();
    }
}
